import React from 'react';
import logoIPMI from '../../assets/img/IPMI.png';
import { Objetive } from './Components/Objetive';
import { CardToInstitutes } from './Components/CardToInstitutes';
import { CardQuote } from '../../components/CardQuote';
import { Flow } from '../../workflows/Flow';
import { nodes, edges } from './matterFlow';

export function InstituteForPastoesAndChildrensMinisters() {
  return (
    <div className="container-fluid bg-light min-vh-100 pb-5">
      {/* --- Encabezado Principal --- */}
      <header className="container py-5 text-center">
        <div className="mb-4">
          <img 
            src={logoIPMI} 
            alt='Logo IPMI' 
            className="img-fluid"
            style={{ maxWidth: '160px', filter: 'drop-shadow(0px 4px 6px rgba(0,0,0,0.1))' }} 
          />
        </div>
        <h1 className="display-4 fw-bold text-uppercase text-success mb-2">
          Instituto para Pastores y Ministras Infantiles
        </h1>
        <p className="text-muted fw-bold">"Hno. Carlos Honorato Ocampo Castañeda"</p>
        <hr className="w-25 mx-auto border-success border-2 opacity-75" />
      </header>

      <main className="container">
        {/* --- Quiénes Somos y Objetivo --- */}
        <section className="row g-4 mb-5">
          <div className="col-lg-6">
            <div className="bg-white p-4 rounded-4 shadow-sm h-100 border-start border-5 border-success">
              <h3 className="h4 fw-bold mb-3 text-success">¿Quiénes somos?</h3>
              <p className="text-secondary lh-lg">
                Somos la institución especializada en la formación de líderes dedicados al recurso más valioso de la iglesia: **la niñez**. 
                Desde 1953, trabajamos para forjar la iglesia del mañana a través de los niños de hoy.
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="bg-success text-white p-4 rounded-4 shadow-sm h-100 d-flex align-items-center shadow">
              <Objetive objetive_info={'Colaborar con Dios y con la ICIAR en la formación de Pastores y Ministras Infantiles que respondan al perfil bíblico.'}/>
            </div>
          </div>
        </section>

        {/* --- Misión, Visión y Funciones --- */}
        <section className="row g-4 mb-5">
          <div className="col-md-4">
            <CardToInstitutes title={'Misión'} info={"Formación académica, doctrinal y espiritual para ministrar eficazmente a la Iglesia Infantil."}/>
          </div>
          <div className="col-md-4">
            <CardToInstitutes title={'Unidad'} info={"Salvaguardar la unidad doctrinal, el orden cultual y el gobierno teocrático en la ICIAR."}/>
          </div>
          <div className="col-md-4">
            <CardToInstitutes title={'Funciones'} info={"Preparar a los alumnos en áreas espirituales y sociales para servir con excelencia a los niños."}/>
          </div>
        </section>

        {/* --- Sección de Reflexión (Destacada) --- */}
        <section className="mb-5">
          <div className="bg-white p-4 p-md-5 rounded-4 shadow-sm border">
            <h3 className="text-success fw-bold mb-4 text-center text-uppercase">Nuestra Visión sobre la Niñez</h3>
            <div className="row align-items-center">
              <div className="col-lg-8">
                <p className="lh-lg text-secondary">
                  "Los niños merecen una atención especial; son la materia prima y el recurso más valioso con que cuenta la iglesia. 
                  Invertir en ellos garantiza dividendos eternos. Forjemos una niñez que conozca, crea y defienda la sana doctrina."
                </p>
                <div className="alert alert-success border-0 bg-success bg-opacity-10 fw-bold">
                   ¡Los niños de ahora son los siervos de Dios del mañana!
                </div>
              </div>
              <div className="col-lg-4 text-center d-none d-lg-block">
                <i className="bi bi-person-heart text-success" style={{ fontSize: '6rem', opacity: 0.2 }}></i>
              </div>
            </div>
          </div>
        </section>

        {/* --- Sección de Llamado (Hero Card) --- */}
        <section className="mb-5">
          <div className="card border-0 rounded-5 overflow-hidden shadow-lg text-white">
            <div style={{
              background: 'linear-gradient(135deg, rgba(25, 135, 84, 0.9), rgba(40, 167, 69, 0.8))',
              position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1
            }}></div>
            <div className="card-body p-5 text-center position-relative" style={{ zIndex: 2 }}>
              <h3 className="fw-bold mb-3 small-caps">¿Llamado a la Enseñanza?</h3>
              <p className="lead mb-4 mx-auto" style={{ maxWidth: '800px' }}>
                "Presentándote tú en todo como ejemplo de buenas obras; en la enseñanza mostrando integridad, seriedad, palabra sana e irreprochable..."
              </p>
              <footer className="blockquote-footer text-white opacity-75 fs-5">Tito 2: 1, 7-8</footer>
            </div>
          </div>
        </section>

        {/* --- Testimoniales (Actualizados) --- */}
        <section className="mb-5">
          <h3 className='text-center text-uppercase fw-bold mb-4 text-success'>Testimonios</h3>
          <div className='row g-4'>
            <div className='col-md-6'>
              <CardQuote 
                person={"Egresada IPMI"} 
                text="Aprender a tratar a los niños como Cristo los trató cambió mi perspectiva ministerial. El instituto me dio las herramientas pedagógicas y espirituales necesarias." 
              />
            </div>
            <div className='col-md-6'>
              <CardQuote 
                person={"Instructor IPMI"} 
                text="Ver la evolución de los alumnos desde el propedéutico hasta su graduación es una bendición. Formamos no solo maestros, sino pastores de corazones pequeños." 
              />
            </div>
          </div>
        </section>

        {/* --- Mapa Curricular --- */}
        <section className="mb-5 p-4 bg-white rounded-4 shadow-sm">
          <h2 className='h4 text-center fw-bold mb-4 text-success text-uppercase'>Materias y Plan de Estudios</h2>
          <div className="border rounded-3 overflow-hidden bg-light">
            <Flow 
              initialEdge={edges}
              initialNode={nodes}
              styleFlow={{ height: '30rem' }}
              disablePanOnDrag={false}
              disableZoomOnScroll={false} 
              disablePanOnScroll={true}
            />
          </div>
        </section>

        {/* --- Historia (Acordeón o Grid Elegante) --- */}
        <section className="p-4 bg-dark text-light rounded-4 shadow">
          <h4 className="fw-bold text-success mb-4 border-bottom border-success pb-2">Nuestra Historia</h4>
          <div className="row g-4 small">
            <div className="col-md-6 border-end border-secondary">
              <p><strong className="text-success">1953:</strong> Surge como Instituto de Escuela Dominical bajo la dirección del Hno. Carlos Honorato Ocampo.</p>
              <p><strong className="text-success">1962-1976:</strong> Periodo de la Hna. Ma. de los Ángeles Díaz; el enfoque cambia a Instructores de Escuela Dominical.</p>
              <p><strong className="text-success">2005:</strong> Bajo la presidencia del Hno. Aarón Cortés, evoluciona a Instituto para Pastores y Ministras Infantiles.</p>
            </div>
            <div className="col-md-6">
              <p>Actualmente, bajo la dirección de la <strong>Hna. Sara Eunice Ontiveros</strong>, contamos con 18 planteles a nivel nacional.</p>
              <p className="fst-italic bg-secondary bg-opacity-25 p-3 rounded">
                "Tratemos a los niños como Cristo los trató, y démosles la importancia que Él les dio."
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}